import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function CloseIcon({ className }: IconBaseType) {
  return (
    <svg
      className={cn("h-4 w-4", className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 7.05L16.95 6L12 10.95L7.05 6L6 7.05L10.95 12L6 16.95L7.05 18L12 13.05L16.95 18L18 16.95L13.05 12L18 7.05Z"
        fill="currentColor"
      />
    </svg>
  );
}
